import { getCanvas } from "kontra";
import { Panel } from "./panel";

export {
  $,
  $$,
  configCanvas,
  Panel,
  proportionalPlacement
};

// based on https://gist.github.com/paulirish/12fb951a8b893a454b32
const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);

// Configuring canvas
function configCanvas(
  canvas: HTMLCanvasElement,
  width = 480,
  height = 320,
  zoom = 1,
  color?: string
) {
  canvas.width = width / zoom;
  canvas.height = height / zoom;
  canvas.style.backgroundColor = color;

  return canvas;
}

function proportionalPlacement({ x = 0, y = 0 }) {
  const canvas = getCanvas();

  if (x) {
    return x * canvas.width;
  }

  return y * canvas.height;
}